export default{
  Version: 'v4.6.6.0'
}



// WEBPACK FOOTER //
// ./src/assets/config/version.js